import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleNavClick = (id) => {
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToSection(id), 300);
    } else {
      scrollToSection(id);
    }
  };

  return (
    <footer
      className="footer"
      style={{
        backgroundColor: "#f5f5f5",
        padding: "30px 0",
        marginTop: "40px",
        borderTop: "1px solid #ddd",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        {/* Logo + descripción */}
        <div style={{ maxWidth: "350px" }}>
          <h3 style={{ marginBottom: "10px", fontWeight: "700", color: "#000"}}>OficiAR</h3>
          <p style={{ lineHeight: "1.6", color: "#555" }}>
            Plataforma que te conecta a vos que necesitas realizar un trabajo con trabajadores capacitados en Argentina.
            Actualmente en fase de desarrollo pero con tu ayuda vamos a mejorar nuestra plataforma.
          </p>
        </div>

        {/* Navegación interna */}
        <div>
          <h4 style={{ marginBottom: "10px", color: "#000"}}>Navegación</h4>
          <ul style={{ listStyle: "none", padding: 0, lineHeight: "1.8" }}>
            
            {/* Inicio con scroll */}
            <li>
              <button
                onClick={() => handleNavClick("inicio")}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  color: "#000",
                  fontSize: "16px",
                }}
              >
                Inicio
              </button>
            </li>

            {/* Tareas */}
            <li>
              <button
                onClick={() => navigate("/maintenance")}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  color: "#000",
                  fontSize: "16px",
                }}
              >
                Tareas
              </button>
            </li>

            {/* Login */}
            <li>
              <button
                onClick={() => navigate("/login")}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  color: "#000",
                  fontSize: "16px",
                }}
              >
                Ingresar
              </button>
            </li>

            {/* Register */}
            <li>
              <button
                onClick={() => navigate("/register")}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  color: "#000",
                  fontSize: "16px",
                }}
              >
                Registrarse
              </button>
            </li>

          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 style={{ marginBottom: "10px", color: "#000"}}>Legal</h4>
          <ul style={{ listStyle: "none", padding: 0, lineHeight: "1.8" }}>
            <li>
              <button
                onClick={() => navigate("/maintenance")}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  color: "#000",
                  fontSize: "16px",
                }}
              >
                Términos y Privacidad
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/maintenance")}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  color: "#000",
                  fontSize: "16px",
                }}
              >
                Política de Privacidad
              </button>
            </li>
          </ul>
        </div>

        {/* Contacto */}
        <div>
          <h4 style={{ marginBottom: "10px", color: "#000"}}>Contacto</h4>
          <p style={{color: "#333"}}>Rosario, Santa Fe, Argentina</p>

          <p>
            <a href="mailto:oficiar.soporte@gmail.com" style={{ color: "#333" }}>
              oficiar.soporte@gmail.com
            </a>
          </p>

          <p>
            <a href="https://www.instagram.com/ofici_ar/" style={{ color: "#333" }}>
              Instagram
            </a>
          </p>
        </div>
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "30px",
          color: "#777",
          fontSize: "14px",
        }}
      >
        © {new Date().getFullYear()} OficiAR. Todos los derechos reservados.
      </div>
    </footer>
  );
}
